import foreignCoOwnersModel from 'forms/sections/foreign/activities/shared/foreignCoOwners';
import { namePattern } from 'constants/patterns';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { REQUIRED, SOLD_DATE_TOO_EARLY } from 'constants/errors';
import currencyModelValidator from 'forms/shared/validators/models/currency/currency';
import { isPVQForm } from 'helpers/form';
import nameModelValidator from 'forms/shared/validators/models/name/name';
import { foreignContactRelationshipOptions, foreignFinancialInterestOptions } from 'constants/enums/foreignActivityOptions';
import { ForeignActivitiesIndirectItemModel } from '../types';

export const foreignActivitiesIndirectItemValidator: ValidateJSModel<ForeignActivitiesIndirectItemModel> = {
  InterestTypes: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }
    return {
      presence: true,
      array: {
        validator: { presence: true },
        length: { minimum: 1, message: REQUIRED },
      },
    };
  },

  InterestType: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }
    return { hasValue: true };
  },

  Firstname: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }
    return {
      hasValue: {
        validator: {
          format: {
            pattern: namePattern,
            message: 'error.name.first.pattern',
          },
        },
      },
    };
  },

  Lastname: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }
    return {
      hasValue: {
        validator: { format: { pattern: namePattern, message: 'error.name.last.pattern' } },
      },
    };
  },

  RelationshipNature: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }
    return { hasValue: true };
  },

  Acquired: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }
    const { applicantBirthdate } = options;
    return {
      presence: true,
      date: {
        requireYear: false,
        earliest: applicantBirthdate,
        tooEarly: 'error.applicantMin',
      },
    };
  },

  HowAcquired: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }

    return { hasValue: true };
  },

  Cost: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }

    return {
      presence: true,
      model: {
        validator: currencyModelValidator,
      },
    };
  },

  Sold: (value, attributes, attributeName, options) => {
    if (attributes?.SoldNotApplicable?.applicable === false || !attributes?.Acquired || isPVQForm(options?.formType)) { return {}; }

    return {
      presence: true,
      date: {
        earliest: attributes?.Acquired,
        tooEarly: SOLD_DATE_TOO_EARLY,
        latest: DEFAULT_LATEST,
      },
    };
  },
 
  CoOwners: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }

    return {
      presence: true,
      model: {
        validator: foreignCoOwnersModel,
      },
    };
  },

  CostEstimated: {},

  ValueEstimated: {},

  SoldNotApplicable: {},
  // pvq shared
  Explanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }

    if (attributes?.SoldNotApplicable?.applicable === false) { return {}; }

    return { hasValue: true };
  },
  Value: (value, attributes, attributeName, options) => ({
    presence: true,
    model: {
      validator: currencyModelValidator,
    },
  }),

  // pvq only
  Name: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        presence: true,
        model: { validator: nameModelValidator },
      };
    }
    return {};
  },

  RelationshipType: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        hasValue: {
          validator: {
            inclusion: {
              within: foreignContactRelationshipOptions,
            },
          },
        },
      };
    }
    return { };
  },

  InterestTypeExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.FinancialInterestType?.value?.includes('Other')) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  Country: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  FinancialInterestType: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        hasValue: {
          validator: {
            inclusion: {
              within: foreignFinancialInterestOptions,
            },
          },
        },
      };
    }
    return {};
  },

};
